module.exports = __webpack_public_path__ + "img/09-atelier-transver.39658e43.jpg";